if (!customElements.get('kf-collection-views')) {
  customElements.define('kf-collection-views', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = matchMedia('(max-width: 767px)');
      this.imageLinkAttributes = new WeakMap();
      this.columns = {};
      for (const size of ['mobile', 'desktop']) {
        try {
          const value = sessionStorage.getItem(`kf-collection-view-${size}`);
          if (['1', '2', '4'].includes(value)) this.columns[size] = value;
        } catch (_) {}
      }
      this.onClick = (event) => {
        const button = event.target.closest('[data-kf-columns]');
        if (!button || button === this || !this.contains(button)) return;
        const size = this.breakpoint.matches ? 'mobile' : 'desktop';
        this.columns[size] = button.dataset.kfColumns;
        try { sessionStorage.setItem(`kf-collection-view-${size}`, this.columns[size]); } catch (_) {}
        this.sync();
      };
      this.scheduleSync = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.addEventListener('click', this.onClick);
      this.breakpoint.addEventListener('change', this.scheduleSync);
      this.observer = new MutationObserver((records) => {
        if (records.some(record => record.type === 'childList' || record.target.tagName === 'FILTER-CONTAINER')) this.scheduleSync();
      });
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.sync();
    }
    sync() {
      const discoveryLink = this.querySelector('[data-kf-discovery]');
      if (discoveryLink) {
        const original = new URL(discoveryLink.getAttribute('href'), location.origin);
        const target = new URL(location.href);
        target.pathname = original.pathname;
        for (const key of ['page', 'section_id']) target.searchParams.delete(key);
        if (original.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', original.searchParams.get('preview_theme_id'));
        target.searchParams.set('view', 'entdecken');
        discoveryLink.href = target.href;
      }
      const size = this.breakpoint.matches ? 'mobile' : 'desktop';
      const columns = this.columns[size] || (size === 'mobile' ? '2' : this.dataset.defaultDesktop || '4');
      this.dataset.kfColumns = columns;
      const imagesOnly = this.breakpoint.matches && columns === '4';
      this.querySelectorAll('#product-grid .image-cont > a.product-link').forEach(link => {
        if (imagesOnly) {
          if (!this.imageLinkAttributes.has(link)) {
            this.imageLinkAttributes.set(link, {
              'aria-hidden': link.getAttribute('aria-hidden'),
              tabindex: link.getAttribute('tabindex')
            });
          }
          link.removeAttribute('aria-hidden');
          link.removeAttribute('tabindex');
        } else if (this.imageLinkAttributes.has(link)) {
          for (const [name, value] of Object.entries(this.imageLinkAttributes.get(link))) {
            if (value === null) link.removeAttribute(name);
            else link.setAttribute(name, value);
          }
          this.imageLinkAttributes.delete(link);
        }
      });
      this.querySelectorAll('button[data-kf-columns]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.kfColumns === (Number(columns) > 2 ? '4' : columns)));
      });
      const filters = this.querySelector('filter-container');
      const expanded = filters?.classList.contains(`filter-container--show-filters-${size}`) || false;
      this.querySelectorAll('.kf-collection-toolbar__filter').forEach(button => button.setAttribute('aria-expanded', String(expanded)));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.breakpoint?.removeEventListener('change', this.scheduleSync);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

